export default __webpack_public_path__ + "static/char-58-anr-c6334f51a1aa940e32cc35da31acccb5.webp";